import React, { Fragment } from 'react';
import { api } from '../api';
import { Button, Form } from 'react-bootstrap';

class ReviewableItemCreator extends React.Component {
    constructor() {
        super();

        this.state = {
            name: "",
            description: "",
        };
    }

    async createReviewableItem(event) {
        event.preventDefault();
        const created = await api.createItem({
            name: this.state.name,
            description: this.state.description,
            vendorId: this.props.vendorId,
        });
        this.setState({ reviewableItemId: created.id });
    }

    async updateStateValue(event, stateKey) {
        event.preventDefault();
        this.setState({ [stateKey]: event.target.value });
    }

    render() {
        return (
            <Fragment>
                <div style={{ padding: "24px 12px 24px 12px", marginTop: "100px", marginBottom: "100px" }}>
                    <h1>Create Doughnut</h1>
                    <Form
                        noValidate
                        onSubmit={e => this.createReviewableItem(e)}>
                        <Form.Group>
                            <Form.Control style={{ width: "353px", marginBottom: "12px" }} type="text" placeholder="Doughnut Name" onChange={e => this.updateStateValue(e, "name")}/>
                            <Form.Control style={{ width: "353px", marginBottom: "12px" }} type="text" placeholder="Doughnut Description" onChange={e => this.updateStateValue(e, "description")}/>
                            <Button variant="primary" type="submit" style={{ float: "right"}}>
                                Create
                            </Button>
                        </Form.Group>
                    </Form>
                </div>
            </Fragment>
        );
    }
}

export { ReviewableItemCreator };
